// Ported from Magnum.Web resources/js/modules/property-details/url-cleanup.js

// email click, map click, list click, sticky property click, page
const TRACKING_PARAMS = ["ce", "cm", "cs", "st", "p"];

// Per-search correlation token generated by the Magnum.Web results pages
// (PropertiesController.SearchResults). Its only reader was back-navigation.js on the old
// property page, which this page replaced with a Referer-derived back link, so it is inert here.
// The old page stripped it too whenever it didn't match the sessionStorage value.
const LEGACY_SEARCH_PARAMS = ["sid"];

const PARAMS_TO_REMOVE = [...TRACKING_PARAMS, ...LEGACY_SEARCH_PARAMS];

/**
 * Removes the reporting params from the address bar once the server has recorded them,
 * leaving every other param (utm_*, gclid, ...) intact so campaign attribution survives.
 */
export function cleanTrackingParamsFromUrl() {
  const url = new URL(window.location.href);
  let changed = false;

  // Legacy Magnum.Web links use uppercase (?CE=1&ST=1), so match case-insensitively.
  // Snapshot the keys first — mutating URLSearchParams mid-iteration can skip entries.
  for (const name of [...url.searchParams.keys()]) {
    if (PARAMS_TO_REMOVE.includes(name.toLowerCase())) {
      url.searchParams.delete(name);
      changed = true;
    }
  }

  if (changed) {
    window.history.replaceState(null, "", url.href);
  }
}
